module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/carton2.46edb907.jpg";